import React from "react";

const Contact = () => {
  return (
    <div className="contact">
      {" "}
      <h1>This is conatct page</h1>
    </div>
  );
};

export default Contact;
